export const notificationAPIs = {
  add: {
    url: 'notifications',
    method: 'post',
    isAuthEnabled: true,
  },
  delete: {
    url: 'notifications',
    method: 'delete',
    isAuthEnabled: true,
  },
  get: {
    url: 'notifications',
    method: 'get',
    isAuthEnabled: true,
  },
  update: {
    url: 'notifications',
    method: 'patch',
    isAuthEnabled: true,
  },
  send: {
    url: 'userNotifications/sendNotification',
    method: 'post',
    isAuthEnabled: true,
  },
  getUsers: {
    url: 'users/all',
    method: 'get',
    isAuthEnabled: true,
  },
};
